import { Typography, Box } from '@mui/material';
import { CategoryChooser, RelatedArticleData } from '../../models/app-data-model';
import RelatedArticle from '../related-article/RelatedArticle';
import './RelatedArticleGroup.scss';

import React from 'react';

export type RelatedArticleGroupProps = {
  relatedArticleGroupData?: RelatedArticleData[];
  categoryChooser?: CategoryChooser[];
};

const RelatedArticleGroup: React.FC<RelatedArticleGroupProps> = (props: RelatedArticleGroupProps) => {
  const relatedArticleData = props?.relatedArticleGroupData?.map((article, index) => <RelatedArticle relatedArticleData={article.seo} url={article.url} created_date={article?.created_at} categoryChooser={props?.categoryChooser && props?.categoryChooser[0]} key={index}></RelatedArticle>);

  return (
    <div className="related-article-wrapper">
      <h4>Related Articles</h4>
      <Box className='related-article-group'>
        {relatedArticleData}
      </Box>
    </div>
  );
};

export default RelatedArticleGroup;
